/*global KF*/

import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import {
  Container,
  Grid,
  Header,
  Button,
  Divider,
  Segment,
  List,
  Image,
  Item,
  Icon,
  Card,
  Search,
  Progress
} from 'semantic-ui-react'

export default class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dashboard: null
    }
  }

  componentDidMount () {
    console.log(this.props.match)
    this.setState({dashboard: this.props.match.params.dashboard})
  }

  render () {
    if (!this.state.dashboard) {
      return <div></div>
    }
    return (
      <div style={{height: '100%', width: '100%'}}>
        <iframe
          width="100%"
          height="100%"
          style={{width: '100%', height: "100%", border: 'none'}}
          src={`https://app.gogrow.com/dashboard/share/${this.state.dashboard}`}>
        </iframe>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/container/insights/index.js